import { get } from 'lodash';

import actions, { MODAL_TYPES } from 'state/constants';
import initialState from 'state/initialState';

const openModalReducer = (state, action) => {
  const modalType = get(action, 'payload');
  const purpose = get(action, 'meta.purpose');
  const decision = get(action, 'meta.decision');
  return {
    ...state,
    modal: modalType,
    modalSignUpPurpose: purpose,
    modalConsentConfirmationDecision: decision,
  };
};

const closeModalReducer = state => ({
  ...state,
  modal: MODAL_TYPES.NONE,
  modalSignUpPurpose: null,
});

export const reducer = (state = initialState.app, action) => {
  switch (action.type) {
    case actions.OPEN_MODAL:
      return openModalReducer(state, action);
    case actions.CLOSE_MODAL:
      return closeModalReducer(state);
    default:
      return state;
  }
};

export default reducer;
